import { createAppKit } from '@reown/appkit/react';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { baseSepolia } from '@reown/appkit/networks';
import { cookieStorage, createStorage } from 'wagmi';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { environment } from './environment';

// Get project ID from environment
const projectId = environment.projectId;

// Define metadata for your app
const metadata = {
  name: 'SaharaLabs Token Vesting',
  description: 'Token vesting and distribution platform',
  url: 'https://saharalabs.ai',
  icons: ['https://saharalabs.ai/icon.png']
};

// Configure networks - focusing on Base Sepolia for this project
const networks = [baseSepolia];

// Create Wagmi Adapter
export const wagmiAdapter = new WagmiAdapter({
  storage: createStorage({
    storage: cookieStorage
  }),
  ssr: false,
  projectId,
  networks
});

// Create AppKit instance
export const modal = createAppKit({
  adapters: [wagmiAdapter],
  projectId,
  networks,
  metadata,
  features: {
    analytics: true,
    email: false,
    socials: []
  },
  themeMode: 'dark',
  themeVariables: {
    '--w3m-accent': '#f8ffad',
    '--w3m-color-mix': '#1a1a1a',
    '--w3m-color-mix-strength': 25,
    '--w3m-border-radius-master': '12px',
    '--w3m-font-family': 'Inter, ui-sans-serif, system-ui, sans-serif'
  },
  defaultNetwork: baseSepolia,
  // allowUnsupportedChain: false will force network switching
  allowUnsupportedChain: false
});

// Create QueryClient for React Query
export const queryClient = new QueryClient();

// Export Wagmi config
export const wagmiConfig = wagmiAdapter.wagmiConfig;
